import * as React from 'react';

import Navigation from '~/UI/Navigation/Navigation';
import NavigationMenu from '~/UI/NavigationMenu';
import { UserNavigationItem } from '~/UserNavigationItem';

const ERPHeader = () => {
	return (
		<div style={{ height: '61px' }}>
			<Navigation bottomPanel={null} innerContainerStyle={{ maxWidth: '1360px' }} panel={<UserNavigationItem />}>
				<NavigationMenu />
			</Navigation>
		</div>
	);
};

export default React.memo(ERPHeader);
